import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';
import { IActionFn } from '@/store/types';

// 修改密码
export const updatePassword: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/auth/user/password', payload);
    await $http.post('/v1/auth/user/password', payload);
    store.commit('common/setToast', { visible: true, text: '修改密码成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 修改会员密码
export const updateMemberPassword: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/auth/member/password', payload);
    await $http.post('/v1/auth/member/password', payload);
    store.commit('common/setToast', { visible: true, text: '修改密码成功' });
  } finally {
    commit('setLoading', false);
  }
};
